import Image from "../../../../content/arts/2021/01/30/botticelli-painting-80-million-dollar/painting-63186_640.jpg";
import * as React from 'react';
export default {
  Image,
  React
};